import React from "react";
import Image from "next/image";

import ContentBlock from "../ContentBlock";
import {
  Container,
  CustomCollapse,
  CustomCollapsePanel,
  IconWrap,
} from "./styled";
import { faqData } from "../../_faqs";

const FAQCollapse = () => {
  const ExpandIconPlus = () => (
    <IconWrap>
      <Image
        alt="collapse icon plus"
        src="/icons/collapse_plus.png"
        width={17}
        height={17}
        loading="lazy"
        quality={100}
      />
    </IconWrap>
  );

  const ExpandIconClose = () => (
    <IconWrap>
      <Image
        alt="collapse icon close"
        src="/icons/collapse_close_purple.png"
        width={17}
        height={17}
        loading="lazy"
        quality={100}
      />
    </IconWrap>
  );

  return (
    <Container>
      <CustomCollapse
        // defaultActiveKey={["0"]}
        expandIconPosition="left"
        expandIcon={({ isActive }) =>
          isActive ? <ExpandIconClose /> : <ExpandIconPlus />
        }
        accordion
      >
        {faqData.map((faq, key) => (
          <CustomCollapsePanel header={faq.title} key={key}>
            <div>
              {faq.content.map((item, index) => (
                <ContentBlock
                  key={index}
                  title={item.title}
                  contents={item.contents}
                />
              ))}
            </div>
          </CustomCollapsePanel>
        ))}
      </CustomCollapse>
    </Container>
  );
};

export default FAQCollapse;
